import { Buffer } from 'buffer';

export const isClubAdmin = props =>
  props.login.isAuthenticated &&
  (props.login.role === 'Club Admin' || props.login.role === 'In-House Admin' || props.login.role === 'Super Admin');

export const isInHouseAdmin = props =>
  // console.log('isInHouseAdmin', props.login.role);
  props.login.isAuthenticated && (props.login.role === 'In-House Admin' || props.login.role === 'Super Admin');

export const isSuperAdmin = props => props.login.isAuthenticated && props.login.role === 'Super Admin';

export const parseJwt = token => {
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return null;
    }

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    const json = Buffer.from(base64 + padding, 'base64').toString('utf-8');

    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};
